import parsePhoneNumber from 'libphonenumber-js';
import 'libphonenumber-js/min';

// Once the input is done, we can also check overall length for NANP numbers.
export function isValidInternationalPhoneNumber(
  phone: string | null | undefined,
): boolean {
  return !!parsePhoneNumberForgivingly(phone)?.isValid();
}

// Format a number as e.g. +44525285822, for Twilio
export function formatInternationalPhoneNumberE164(
  phone: string | undefined | null,
): string | null {
  const number = parsePhoneNumberForgivingly(phone);
  return number?.number as string;
}

export function formatInternationalPhoneNumberHuman(phone: string): string {
  const number = parsePhoneNumberForgivingly(phone);
  if (number) {
    return number.formatInternational();
  }
  // Internal demo services on sandbox and QA produce sample data that includes
  // invalid US phone numbers. They'll fall down this branch along with other invalid numbers
  if (phone.length == 11) {
    return `+${phone.substring(0, 1)} ${phone.substring(2, 4)} ${phone.substring(4, 7)} ${phone.substring(7)}`;
  }
  return phone;
}

// User input is biased towards US domestic numbers, but we want to give
// ourselves every chance of successfully parsing international numbers without
// forcing the user to type `+`. This tries assuming US, and if that produces an
// invalid number, tries assuming a country code is present.
function parsePhoneNumberForgivingly(phone: string | undefined | null) {
  if (!phone) return undefined;
  // Assume US number, unless it's got a + and a country code
  let number = parsePhoneNumber(phone, 'US');
  // If it's not a valid US number, but doesn't have a plus, try that
  if (!number?.isValid()) {
    number = parsePhoneNumber('+' + phone);
  }
  return number;
}
